import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Application entry point.
 *
 * Domain configuration for the doors business (sales + installation).
 * Stage/type lists below are the initial seed; admins can adjust them later
 * in Settings (stored in the `configuration` table).
 */

const dealStages = [
  { value: "new", label: "Новая" },
  { value: "in-progress", label: "Взята в работу" },
  { value: "measurement", label: "Замер" },
  { value: "quote", label: "КП / Счёт" },
  { value: "paid", label: "Оплачена" },
  { value: "install-scheduled", label: "Монтаж назначен" },
  { value: "installed", label: "Монтаж выполнен" },
  { value: "closed", label: "Закрыта" },
  { value: "lost", label: "Проиграна" },
];

// Stages that count as "won" for reports and the revenue chart
const dealPipelineStatuses = ["closed"];

const dealCategories = [{ value: "doors", label: "Двери" }];

const taskTypes = [
  { value: "none", label: "Без типа" },
  { value: "call", label: "Звонок" },
  { value: "measurement", label: "Замер" },
  { value: "delivery", label: "Доставка" },
  { value: "installation", label: "Монтаж" },
  { value: "meeting", label: "Встреча" },
  { value: "follow-up", label: "Напомнить" },
];

const noteStatuses = [
  { value: "cold", label: "Холодный", color: "#7dbde8" },
  { value: "warm", label: "Тёплый", color: "#e8cb7d" },
  { value: "hot", label: "Горячий", color: "#e88b7d" },
  { value: "in-contract", label: "Договор", color: "#a4e87d" },
];

const App = () => (
  <CRM
    title="CRM"
    currency="RUB"
    dealStages={dealStages}
    dealPipelineStatuses={dealPipelineStatuses}
    dealCategories={dealCategories}
    taskTypes={taskTypes}
    noteStatuses={noteStatuses}
    disableTelemetry
  />
);

export default App;
